<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addLine">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="部门名称" prop="DEPARTMENT_NAME"></el-table-column>
          <el-table-column label="是否计入销售">
            <template slot-scope="scope">
              <span>{{ sellStatus[scope.row.BE_SALE] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="30px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="edit(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="stop(scope.row)" v-if="scope.row.STATUS == 1"
                style="color: red">禁用</el-button>
              <el-button type="text" size="small" @click="open(scope.row)" v-else style="color: green">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增部门" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small">
        <el-form-item label="部门名称：" :label-width="formLabelWidth">
          <el-input v-model="addForm.DEPARTMENT_NAME" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="是否计入销售：" :label-width="formLabelWidth">
          <el-radio v-model="addForm.BE_SALE" label="0">否</el-radio>
          <el-radio v-model="addForm.BE_SALE" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="$_submitAction()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryDepartment, submitDepartment, editDepartment, stopDepartment, openDepartment,
} from 'api/systemSetting';

export default {
  data() {
    return {
      // loading:false,
      tableData: [],
      addFormVisible: false,
      lineInput: '',
      addForm: {},
      formLabelWidth: '120px',
      sellStatus: ['不计销售', '计入销售'],
      editFlag: 0,
    };
  },
  created() {
    this.$_queryList();
  },
  methods: {
    // 获取线路配置的信息
    $_queryList() {
      queryDepartment().then((res) => {
        this.tableData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 点击新增
    addLine() {
      this.editFlag = 0;
      this.addFormVisible = true;
    },
    edit(row) {
      this.editFlag = 1;
      this.addFormVisible = true;
      this.addForm = row;
      this.addForm.BE_SALE = row.BE_SALE.toString();
    },
    $_submitAction() {
      if (this.editFlag == 0) {
        this.$_submitAdd();
      } else {
        this.$_submitEdit();
      }
    },
    $_submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const data = {
            DEPARTMENT_NAME: this.addForm.DEPARTMENT_NAME,
            BE_SALE: this.addForm.BE_SALE,
          };
          if (!this.addForm.DEPARTMENT_NAME || !this.addForm.BE_SALE) {
            this.$message.show({ text: '请输入部门名称并选定是否计入销售', type: 'warning' });
            return false;
          }
          submitDepartment(data).then((res) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.$_queryList();
            // this.loading = false
            document.body.style.cursor = 'default';
          }).catch((error) => {
            // this.loading = false
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    $_submitEdit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const data = {
            DEPARTMENT_NAME: this.addForm.DEPARTMENT_NAME,
            BE_SALE: this.addForm.BE_SALE,
            DEPARTMENT_ID: this.addForm.ID,
          };
          if (!this.addForm.DEPARTMENT_NAME || !this.addForm.BE_SALE) {
            this.$message.show({ text: '请输入部门名称并选定是否计入销售', type: 'warning' });
            return false;
          }
          editDepartment(data).then((res) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.addFormVisible = false;
            this.$_queryList();
            // this.loading = false
            document.body.style.cursor = 'default';
          }).catch((error) => {
            // this.loading = false
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    stop(row) {
      const data = {
        DEPARTMENT_ID: row.ID,
      };
      stopDepartment(data).then((res) => {
        this.$message.show({ text: '禁用成功', type: 'success' });
        this.$_queryList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    open(row) {
      const data = {
        DEPARTMENT_ID: row.ID,
      };
      openDepartment(data).then((res) => {
        this.$message.show({ text: '启用成功', type: 'success' });
        this.$_queryList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/departmentManage.vue